import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export function TwitchRedirect(): JSX.Element {
  const history = useHistory();

  useEffect(() => {
    if (!window.opener) {
      history.push('/auth/signin');
    }

    const { hash } = window.location;
    const token = hash ? hash.match(/#(?:access_token)=([\S\s]*?)&(?:id_token)=([\S\s]*?)&/) : null; // access token
    if (token && token.length > 2) {
      window.opener.postMessage({ accessToken: token[1], idToken: token[2] }, '*');
    }

    window.close();
  }, []);

  return (
    <div className='container'>
      <div className='auth-container'>
        <div className='auth-card'>
          <div className='row'>
            <div className='col text-center'>
              <p>Redirect...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
